import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap items-center gap-x-2"
}
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-red-500 capitalize"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "relative flex group"
}
const _hoisted_6 = { class: "capitalize text-primary" }
const _hoisted_7 = { class: "fixed right-0 w-64 px-1 m-1 mx-auto text-sm text-gray-100 transition-opacity -translate-x-3 bg-gray-800 rounded-md opacity-0 cursor-not-allowed group-hover:opacity-100 -translate-y-1/3" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "relative flex group"
}
const _hoisted_10 = { class: "capitalize text-primary" }
const _hoisted_11 = { class: "fixed right-0 w-64 px-1 m-1 mx-auto text-sm text-gray-100 transition-opacity -translate-x-3 bg-gray-800 rounded-md opacity-0 cursor-not-allowed group-hover:opacity-100 -translate-y-1/3" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-wrap items-center gap-x-2"
}

import { PropType } from "vue";
import { Booking } from "@/types";

import ExternalLink from "@/components/ExternalLink.vue";
import { useUserStore } from "@/store";

import { getCertificateUrl, shouldShowCertificateUrl } from "@/utils/certificates";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBookingsViewButton',
  props: {
  booking: {
    type: Object as PropType<Booking>,
    required: true,
  },
  urls: {
    type: Object as PropType<{ training_survery_url: string; outstanding_surveys: [] }>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { user } = useUserStore();



/**
 * Check if booking is introductory course, free or continuing professional development
 */
function isDirectAccessBooking(booking: Booking): boolean {
  return booking.event!.type === "introductory" || booking.payment_method === "Free" || booking.event!.type === "continuing-professional-development";
}

function buildFeedbackUrl(booking: Booking) {
  return `${props.urls.training_survery_url}?e=${booking.event_id}&c=${booking.event?.template_id}&u=${user.id}&cty=${booking.country}&un=${encodeURI(
    user.first_name + " " + user.last_name
  )}`;
}

function hasOutstandingSurveys() {
  return props.urls.outstanding_surveys.length > 0;
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.booking.user_attended)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.booking.user_removed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.$t("removed")) + ")", 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (isDirectAccessBooking(__props.booking))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (__props.booking.payment_confirmed)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/dashboard/courses/events/${__props.booking.event?.id}`,
                            class: "capitalize text-primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true),
                      (!__props.booking.payment_confirmed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("view")), 1),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("course-blocked-pending-payment")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (__props.booking.payment_confirmed && __props.booking.accepted_terms_conditions)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/dashboard/courses/events/${__props.booking.event?.id}`,
                            class: "capitalize text-primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("view")), 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("course-blocked-pending-payment")), 1)
                          ]))
                    ]))
              ])),
          (!__props.booking.user_attended && __props.booking.event?.type === 'e-learning')
            ? (_openBlock(), _createBlock(ExternalLink, {
                key: 2,
                type: "text",
                label: "View E-learning",
                href: `https://training.playincluded.com/my/`
              }, null, 8, ["href"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.booking.user_attended)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (hasOutstandingSurveys())
            ? (_openBlock(), _createBlock(ExternalLink, {
                key: 0,
                type: "text",
                label: "Give Feedback",
                href: buildFeedbackUrl(__props.booking)
              }, null, 8, ["href"]))
            : _createCommentVNode("", true),
          (_unref(shouldShowCertificateUrl)(__props.booking))
            ? (_openBlock(), _createBlock(ExternalLink, {
                key: 1,
                type: "text",
                label: "View Certificate",
                href: _unref(getCertificateUrl)(__props.booking, __props.booking.user)
              }, null, 8, ["href"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})